var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.525146 10.4503L5.47489 5.50053L0.525146 0.550781","stroke":"#1D1616"}));
}

ChevronRight.defaultProps = {"width":"7","height":"11","viewBox":"0 0 7 11","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
